import { render, staticRenderFns } from "./FAWSUploadFileField.vue?vue&type=template&id=5c4f130b&"
import script from "./FAWSUploadFileField.vue?vue&type=script&lang=ts&"
export * from "./FAWSUploadFileField.vue?vue&type=script&lang=ts&"
import style0 from "./FAWSUploadFileField.vue?vue&type=style&index=0&id=5c4f130b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports